/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationsFilterBase {
    getFixupPrototypeFunction() { return RecommendationsFilterBase.fixupPrototype; }

    static newInstance(model: Partial<RecommendationsFilterBase>): RecommendationsFilterBase {
        let obj = Object.assign(new RecommendationsFilterBase(), model);
        RecommendationsFilterBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationsFilterBase>): RecommendationsFilterBase {
        if (!model) return null;
        return RecommendationsFilterBase.newInstance(<RecommendationsFilterBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationsFilterBase) {
        if (!obj) return;

        models.RecommendationsFilterBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationsFilterBase): boolean {
        Object.setPrototypeOf(obj, RecommendationsFilterBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Service Account Ids to Filter
     */
    service_account_ids: Array<string>;

    /**
     * Query expression to filter line items.
     */
    query: models.QueryOperator;

    /**
     * specify the start date.
     */
    start_date: Date;

    /**
     * specify the end date.
     */
    end_date: Date;

}
